import React, { useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import { Typography, Box } from "@mui/material";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import {
  yellow,
  blue,
  red,
  orange,
  green,
  brown,
  pink,
  purple,
} from "@mui/material/colors";
import { MantineReactTable } from "mantine-react-table";
import { Button, TextField } from "@material-ui/core";
import { IconDownload } from "@tabler/icons-react";
import axios from "../../utils/axiosInstance";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatUTCToLocal } from "utils/timezone";
import Pagination from "rc-pagination";
const useStyles = makeStyles((theme) => ({
  ...styles,
  ballContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: theme.spacing(1),
  },
  cardContent: {
    position: "relative",
    padding: theme.spacing(2),
  },
  ballRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    margin: theme.spacing(-0.5),
  },
  ball: {
    width: 56,
    height: 56,
    fontSize: 24,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    borderRadius: "50%",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",

    margin: theme.spacing(0.3),
    backgroundImage: (props) =>
      `linear-gradient(135deg, ${props.color} 30%, ${props.colorDark} 90%)`,
  },
  ballText: {
    marginTop: theme.spacing(1),
  },
}));

export default function ManageJackpot() {
  // const [tableData, setTableData] = useState([{}]);
  const [jackpotData, setJackpotData] = React.useState([]);
  const [lastSevenAccAmt, setLastSevenAccAmt] = React.useState([]);
  const [getNextLatestLottery, setGetNextLatestLottery] = React.useState({});
  const [getAllJackpotHistory, setGetAllJackpotHistory] = React.useState([]);
  console.log(getAllJackpotHistory, "getAllJackpotHistorygetAllJackpotHistory");
  const [spinningBallData, setSpinningBallData] = React.useState([]);
  const [getLastlotteryIdAccAmt, setGetLastlotteryIdAccAmt] = React.useState(
    {}
  );
  console.log(getLastlotteryIdAccAmt, "getLastlotteryIdAccAmt");
  const hasData =
    getNextLatestLottery && Object.keys(getNextLatestLottery).length > 0;
  const [jackpotStartAmount, setJackpotStartAmount] = useState("");
  const [jackpotStartAmountResponse, setJackpotStartAmountResponse] = useState(
    {}
  )
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const updatePage = (page) => {
    setCurrentPage(page);
  };

  const getBallColors = (ball) => {
    if (typeof ball !== "number" || isNaN(ball)) {
      return { light: "#9e9e9e", dark: "#616161" }; // fallback gray
    }

    // guard against out-of-range balls (like "-" or higher than colors length)
    const index = (ball - 1) % colors.length;
    return colors[index] || { light: "#9e9e9e", dark: "#616161" };
  };


  const BallForTable = ({ number }) => {
    if (number === "-" || number === undefined) return null;

    const { light, dark } = getBallColors(Number(number));

    return (
      <Box
        sx={{
          width: 24,
          height: 24,
          fontSize: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#fff",
          borderRadius: "50%",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
          backgroundImage: `linear-gradient(135deg, ${light} 30%, ${dark} 90%)`,
          transition: "transform 0.3s ease-in-out",
          "&:hover": {
            transform: "scale(1.3)",
          },
        }}
      >
        {number}
      </Box>
    );
  };


  const numbersObj = spinningBallData[0] ?? null;
  console.log(jackpotData, "jackpotData");
  const classes = useStyles();
  const columns = useMemo(() => [
    {
      header: "Jackpot Startdate",
      accessorKey: "startDate",
      Cell: ({ cell }) => {
        const utcDate = cell.getValue();
        return formatUTCToLocal(utcDate);
      },
      size: 10,
    },
    {
      header: "Start Amount",
      accessorKey: "startAmount",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return typeof value === "number" ? value.toFixed(2) : value;
      },
      size: 10,
    },

    ...[1, 2, 3, 4, 5, 6, 7].map((run) => ({
      header: `Run ${run}`,
      accessorKey: `run${run}`,
      Cell: ({ cell }) => {
        const run = cell.getValue();
        if (!run || run.amount === "-") return "-";
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <span>
              {typeof run.amount === "number" ? run.amount.toFixed(2) : run.amount}
            </span>
            <BallForTable number={run.ball} />
          </Box>
        );
      },
      size: 10,
    })),
    {
      header: "Jackpot Prize",
      accessorKey: "jackpotPrize",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return typeof value === "number" ? value.toFixed(2) : value;
      },
      size: 10,
    },
  ]);
  const colors = [
    { light: yellow[700], dark: yellow[900] },
    { light: blue[700], dark: blue[900] },
    { light: red[700], dark: red[900] },
    { light: pink[900], dark: pink[800] },
    { light: orange[700], dark: orange[900] },
    { light: green[700], dark: green[900] },
    { light: purple[700], dark: purple[900] },
  ];

  const runs = ["run 1", "run 2", "run 3", "run 4", "run 5", "run 6", "run 7"];

  const Ball = ({ number, color, colorDark, run }) => {
    const ballStyles = useStyles({ color, colorDark });

    // Optional: Format run label (e.g., "Run 1" instead of "run1")
    const formattedRun = run.replace("run", "Run ");

    return (
      <Box display="flex" flexDirection="column" alignItems="center" margin={1}>
        <Box className={ballStyles.ball}>{number}</Box>
        <Typography variant="body2" className={ballStyles.ballText}>
          {formattedRun}
        </Typography>
      </Box>
    );
  };


  const BallRow = ({ numbers }) => (
    console.log(numbers, "numbers"),
    <Box className={classes.ballRow}>
      {Object.entries(numbers).map(([run, number], index) => (
        <Ball
          key={index}
          number={number}
          run={run} // pass "run1", "run2", etc.
          color={colors[number - 1]?.light}
          colorDark={colors[number - 1]?.dark}
        />
      ))}
    </Box>
  );

  React.useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      console.log("Tokennnnnn", token);
      try {
        const data = await axios.get(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getLastlotteryIdAccAmt`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        console.log(data, "abhay");
        setGetLastlotteryIdAccAmt(data?.data?.data);
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, []);

  React.useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      console.log("Tokennnnnn", token);
      try {
        const data = await axios.get(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getNextLatestLottery`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        console.log(data, "abhay");
        setJackpotData(data.data.data);
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, []);

  // /api/v1/admin/getNextLatestLottery

  React.useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      console.log("Tokennnnnn", token);
      try {
        const data = await axios.get(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getLastSevenAccAmt`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        console.log(data, "abhay");
        setLastSevenAccAmt(data.data.data);
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, []);

  React.useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      console.log("Tokennnnnn", token);
      try {
        const data = await axios.get(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getNextLatestLottery`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        setGetNextLatestLottery(data?.data?.data);
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, []);

  React.useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const fetchData = async (page) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getAllJackpotHistory?page=${page}&limit=${pageSize}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );

      setGetAllJackpotHistory(response.data.data);
      setTotalRecords(response.data.metaData[0].total);
    } catch (error) {
      console.error(error.message);
    }
  };

  React.useEffect(() => {
    const getBallData = async () => {
      const token = localStorage.getItem("token");

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getRemovedBalls`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        setSpinningBallData(res?.data?.data);
      } catch (err) {
        console.log(err);
      }
    };

    getBallData();
  }, []);



  const handleSetJackpotAmount = async () => {
    if (!jackpotStartAmount) {
      toast.error("Please enter a valid amount.");
      return;
    }
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/setStartAmount`,
        { startAmount: jackpotStartAmount },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );


      setJackpotStartAmountResponse(response?.data?.data);
      toast.success("Jackpot start amount set successfully!")

    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message || "Start amount is required.");
      } else {
        toast.error("An error occurred while setting the jackpot start amount.");
      }
      console.error("Error setting jackpot start amount:", error.message);
    }

  };


  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Manage Jackpot</h4>
            </CardHeader>
            <Box className={classes.cardContent}>
              <Typography variant="h5">
                Jackpot run start date:{" "}
                {hasData ? (
                  <span>
                    {formatUTCToLocal(jackpotData?.lotteryDrawDate)
                    }
                  </span>
                ) : (
                  "No record found"
                )}
              </Typography>
              <Typography variant="h5">
                Previous Jackpot Amount{" "}
                {getLastlotteryIdAccAmt?.jackpotAccumulatedAmt} USDC
              </Typography>
              <h5></h5>
              {lastSevenAccAmt.map((round, index) => (
                <Typography key={index}>
                  Added value after {round?.jackpotRounds} run:{" "}
                  {round?.accumulatedAccAmt} USDT
                </Typography>
              ))}

              <Box display="flex" alignItems="center">
                <Typography variant="h5" sx={{ marginRight: "16px" }}>
                  Next Lottery with Powerball jackpot :{" "}
                  {hasData ? (
                    <span>{getNextLatestLottery?.lotteryName}</span>
                  ) : (
                    "No record found"
                  )}
                </Typography>
              </Box>

              <Box
                display="flex"
                alignItems="center"
                sx={{ marginTop: "20px", gap: "8px" }} // Use gap for spacing between items
              >
                <TextField
                  label="Set Jackpot Start Amount"
                  variant="outlined"
                  style={{
                    minWidth: "250px", // Overall width of the TextField
                    "& .MuiInputBase-input": {
                      minWidth: "250px", // Minimum width for the input field
                    },
                    "& .MuiInputBase-root": {
                      height: "40px", // Consistent height for the input field
                      padding: "0 12px", // Adjust padding for alignment
                    },
                    "& .MuiOutlinedInput-input": {
                      fontSize: "14px", // Adjust font size for the input text
                    },
                  }}
                  value={jackpotStartAmount}
                  onChange={(e) => setJackpotStartAmount(e.target.value)}
                />

                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    height: "40px", // Same height as the text field
                    fontSize: "14px", // Optional: Adjust font size
                    padding: "0 16px", // Consistent padding
                  }}
                  onClick={handleSetJackpotAmount}
                >
                  Set Amount
                </Button>
              </Box>

              <Typography variant="h4" sx={{ marginTop: "15px" }}>
                History
              </Typography>
              {numbersObj ? (
                <Box className={classes.ballContainer}>
                  <BallRow numbers={spinningBallData[0]} />
                </Box>
              ) : (
                <Typography>No balls have been popped yet.</Typography>
              )}

            </Box>

            <MantineReactTable
              columns={columns}
              displayColumnDefOptions={{
                "mrt-row-actions": {
                  mantineTableHeadCellProps: {
                    align: "center",
                  },
                  size: 120,
                },
              }}
              enableColumnFilterModes
              initialState={{ showColumnFilters: true }}
              positionToolbarAlertBanner="bottom"
              data={getAllJackpotHistory}
              enableFullScreenToggle={false}
              enableHiding={false}
              enableDensityToggle={false}
              enableFilters={false}
              enablePagination={false}
              renderTopToolbarCustomActions={({ table }) => (
                <Box
                  sx={{
                    display: "flex",
                    gap: "16px",
                    padding: "8px",
                    flexWrap: "wrap",
                  }}
                >
                </Box>
              )}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px",
              }}
            >
              <Pagination
                pageSize={pageSize}
                current={currentPage}
                total={totalRecords}
                onChange={updatePage}
              />

            </Box>
          </Card>

        </GridItem>


      </GridContainer>
    </>
  );
}
